import React, { useEffect, useState } from 'react'
import {  autoTransPageTabIds, autoTransPageTabs } from '../GSConstants'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import { useSearchParams } from 'react-router-dom'
import AutoReceiveTable from './AutoReceive/AutoReceiveTable'
import AutoBranchTransRecvTable from './AutoBranchTransRecv/AutoBranchTransRecvTable'
import AutoDeliveryTable from './AutoDelivery/AutoDeliveryTable'
import { findObjctByValueFromArrayOfObject } from '../../../common/helper'
const GSAutoTransactionPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id')) || '')
  const [allTabs, setAllTabs] = useState([])
  useEffect(() => {
    const allGSPages = sessionStorage.getItem('token1');
    const allGSPagesActive = JSON.parse(allGSPages);
    if (selectedTab === '') {
      const newData = autoTransPageTabs.filter((item) => findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null)
      // goToTabs(14)
      goToTabs(newData?.[0]?.JobID)
    }
  
    if (allGSPagesActive?.length > 0) {
      setAllTabs(allGSPagesActive)
    } else {
      setAllTabs([])
    }
  }, [searchParams, selectedTab]); 
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
  }
  const getAutoTransactionPageContent = (typeId, label) => {
    switch (typeId) {
      case 481:
        return <AutoBranchTransRecvTable/>
      case 532:
        return <AutoReceiveTable />
      case 533:
        return <AutoDeliveryTable />
      default:
        return label
    }
  }
  return (
    <>
      <Box className="autoTransPageTabContainer">
        <Item sx={{ paddingTop: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={selectedTab} onChange={(e, newValue) => goToTabs(newValue)} aria-label="bsic tabs example">
              {autoTransPageTabs.map((reqType, index) => (
                <Tab key={`sender_${index}`} value={reqType.JobID} label={reqType.name} {...autoTransPageTabIds(reqType.JobID)} 
                sx={{
                  display:
                    findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID',"IsActive")===1
                      ? 'block'
                      : 'none',
                }}
                />
              ))}
            </Tabs>
          </Box>
          {autoTransPageTabs.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
              style={{
                display:
                  findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID',"IsActive")===1
                    ? 'block'
                    : 'none',
              }}
            >
              {selectedTab === reqType.JobID && <Box sx={{ p: 3 }}>{getAutoTransactionPageContent(reqType.JobID, reqType.name)}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}

export default GSAutoTransactionPage
